<template>
<div class="chapter">
<div class="inner_page">
<p class="pttitle" id="pt1"><span><span epub:type="pagebreak" id="page_6" title="6"><span epub:type="pagebreak" id="page_7" title="7"><a href="#/xhtml/Contents#rpt1">PRINCIPLE ONE</a></span></span></span></p>
<p class="pttitlea"><span><span class="hide">   </span><a href="#/xhtml/Contents#rpt1">WATER IS A HUMAN RIGHT</a></span></p>
<p class="leftp"><span><span class="hide">    </span>This principle recognizes that denying people or communities access to drinking water and sanitation is a violation of their human rights. In our world today, wealthy people and corporations have access to all the water they want while millions go without because they cannot pay for it or do not have access to it. The right to water is not free for all, allowing anyone to use all they want for any purpose; rather, it guarantees clean, accessible drinking water and sanitation for personal and domestic use for all. The human right to water places the onus on governments to provide water and sanitation to their people and to prevent harm to the source waters that supply it. Most essentially, the human right to water is an issue of justice, not charity. It requires a challenge to the current power structures that support unequal access to the world’s dwindling freshwater supplies.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part001.vue?f4307928